import { initialState } from './initialState';
import * as constants from './constants';
import produce from 'immer';

// ===========================|| ACCOUNT REDUCER ||=========================== //

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.INIT_PROJECTS:
      return produce(state, (draft) => {
        const projects = action.payload;
        draft.projectIds = [];
        draft.projectsById = {};
        projects.forEach((project, idx) => {
          const { id } = project;
          draft.projectsById[id] = project;
          draft.projectIds.push(id);
          // Select the first project
          if (idx === 0) {
            draft.selectedProjectIds = [id];
            draft.selectedCasingIds = [];
            draft.selectedSensitivityIds = [];
          }
        });
      });

    case constants.SELECT_PROJECTS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedProjectIds = ids;
        draft.selectedCasingIds = [];
        draft.selectedSensitivityIds = [];
      });

    case constants.ADD_PROJECT:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.projectsById[id] = action.payload;
        draft.projectIds.push(id);
        // // Insert new case to select
        // draft.selectedProjectIds.unshift(id);
        draft.selectedProjectIds = [id];
        draft.selectedCasingIds = [];
        draft.selectedSensitivityIds = [];
      });

    case constants.REMOVE_PROJECT:
      return produce(state, (draft) => {
        const id = action.payload;
        // Delete in obj
        delete draft.projectsById[id];
        // Delete in order array
        const idx = draft.projectIds.findIndex((projId) => projId === id);
        if (idx !== -1) draft.projectIds.splice(idx, 1);
        // Delete in selectedProjectIds
        const selectId = draft.selectedProjectIds.findIndex((projId) => projId === id);
        if (selectId !== -1) draft.selectedProjectIds.splice(selectId, 1);
        draft.selectedCasingIds = [];
        draft.selectedSensitivityIds = [];
      });

    case constants.UPDATE_PROJECT:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.projectsById[id] = action.payload;
      });

    case constants.SELECT_CASINGS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedCasingIds = ids;
        draft.selectedSensitivityIds = [];
      });

    case constants.INIT_SENSITIVITIES:
      return produce(state, (draft) => {
        const sensitivites = action.payload;
        draft.sensitivityIds = [];
        draft.sensitivitiesById = {};
        draft.selectedSensitivityIds = [];
        sensitivites.forEach((sensitivity) => {
          const { id } = sensitivity;
          draft.sensitivitiesById[id] = sensitivity;
          draft.sensitivityIds.push(id);
        });
      });

    case constants.SELECT_SENSITIVITIES:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedSensitivityIds = ids;
        draft.selectedHScenarioIds = [];
      });

    case constants.ADD_SENSITIVITY:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.sensitivitiesById[id] = action.payload;
        draft.sensitivityIds.push(id);
        draft.selectedSensitivityIds = [id];
      });

    case constants.REMOVE_SENSITIVITY:
      return produce(state, (draft) => {
        const id = action.payload;
        // Delete in obj
        delete draft.sensitivitiesById[id];
        // Delete in order array
        const idx = draft.sensitivityIds.findIndex((sensitivityId) => sensitivityId === id);
        if (idx !== -1) draft.sensitivityIds.splice(idx, 1);
        // Delete in selectedProjectIds
        const selectId = draft.selectedSensitivityIds.findIndex((sensitivityId) => sensitivityId === id);
        if (selectId !== -1) draft.selectedSensitivityIds.splice(selectId, 1);
      });

    case constants.UPDATE_SENSITIVITY:
      return produce(state, (draft) => {
        const { id } = action.payload;
        draft.sensitivitiesById[id] = action.payload;
      });

    case constants.SELECT_H_SCENARIOS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedHScenarioIds = ids;
      });

    case constants.SELECT_CD_SCENARIOS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedCdScenarioIds = ids;
      });

    case constants.SELECT_DNT_SCENARIOS:
      return produce(state, (draft) => {
        const ids = action.payload;
        draft.selectedDntScenarioIds = ids;
      });

    case constants.SELECT_CURRENT_LAYOUT:
      return produce(state, (draft) => {
        const currentLayout = action.payload;
        draft.currentLayout = currentLayout;
      });

    case constants.UPDATE_SETTINGS:
      return produce(state, (draft) => {
        const settings = action.payload;
        draft.settings = settings;
      });

    default:
      return state;
  }
};

export default reducer;
